module.exports = __webpack_public_path__ + "media/time-management_en_ipad_old.9f7489a3.mp4";